export const SWR_KEYS = {
  CUSTOMERS: '/admin/customers',
  ORDERS: '/admin/orders',
  ARTWORKS_TITLES: '/admin/artworks/titles',
  SETTINGS: '/admin/settings',
  // You can also use functions for dynamic keys
  // customer: (id: string) => `/api/customers/${id}`,
} as const;